import type { FormItemRule } from 'element-plus';
import { useGlobalStore } from '../stores/global';
import { CommonTypes, LanguageUtil } from '@fibl/oxs-common';
import { getI18n } from '@/util/i18n';


export function booleanDisplay(obj: any) {
	let booleanValue = false;
	if (typeof obj !== 'undefined') {
		booleanValue = obj;
	}
	if (booleanValue) {
		return getI18n().t('view.edit.yes');
	}
	return getI18n().t('view.edit.no');
}

export function speciesLocale(obj?: CommonTypes.Labels|Record<LanguageUtil.LocaleCode,string>) {
	if (!obj) return '';
	const store = useGlobalStore();
	if (!Array.isArray(obj)) {
		obj = Object.entries(obj).map(([k, v]) => ({ lang: k as LanguageUtil.LocaleCode, label: v }));
	}
	let toCheck = LanguageUtil.getLanguagePriority(store.websiteStore.locale);
	for (let lang of toCheck) {
		let val = getLocaleEntry(obj, lang);
		if (val) return val;
	}
	return '';
}

export function toLocale(obj: any): string {
	const t = typeof obj;
	if (t === 'number') return obj.toString();
	if (t === 'string') return obj;
	if (t === 'boolean') return booleanDisplay(obj);
	if (t === 'object' && obj) {
		if (!Array.isArray(obj)) {
			obj = Object.entries(obj).map(([k, v]) => ({ lang: k, label: v }));
		}
		const store = useGlobalStore();
		let toCheck = LanguageUtil.getLanguagePriority(store.websiteStore.locale, 'en_GB');
		for (let lang of toCheck) {
			let val = getLocaleEntry(obj, lang);
			if (val) return val;
		}
		if (obj.length > 0) {
			return obj[0].label;
		}
	}
	return '';
}
function getLocaleEntry(arr: { lang: string; label: string }[], lang: string): string | null {
	let entry = arr.find((e) => e.lang === lang);
	return entry ? entry.label : null;
}

export function dateTime(value: string): string {
	if (!value) return '';
	const store = useGlobalStore();
	return store.websiteStore.dateTimeFormatter.format(new Date(value));
}
export function date(value: string): string {
	if (!value) return '';
	const store = useGlobalStore();
	return store.websiteStore.dateFormatter.format(new Date(value));
}

export function setGlobalProps(app: any) {
	const i18n = getI18n();
	const rules: Record<string, FormItemRule[]> = {
		required: [
			{ required: true, message: i18n.t('components.form.requiredRule'), trigger: 'blur' },
		],
	};
	app.config.globalProperties.$filters = {
		dateTime,
		date,
		toLocale,
		speciesLocale
	};
	app.config.globalProperties.$form = {
		getProp,
		rules,
	};
	app.config.globalProperties.$globalStore = useGlobalStore();
}

function getProp(prefix: string, propName: string): string {
	if (!prefix) return propName;
	return `${prefix}.${propName}`;
}

